/** Unités décimales annoncées dans le formulaire : Go=10^9, Mo=10^6. Aucune approximation
 * flottante pour produire les octets qui seront conservés par le serveur. */
export function quotaUnits(value: string, decimals: number): string {
  const match = /^(0|[1-9][0-9]*)(?:[.,]([0-9]+))?$/u.exec(value.trim());
  if (!match || (match[2]?.length ?? 0) > decimals || value.length > 40)
    throw new Error('INVALID_QUOTA_VALUE');
  return (
    BigInt(match[1]!) * 10n ** BigInt(decimals) +
    BigInt((match[2] ?? '').padEnd(decimals, '0') || '0')
  ).toString();
}
export function quotaDisplay(bytes: string, decimals: number): string {
  const value = BigInt(bytes),
    scale = 10n ** BigInt(decimals);
  const fraction = (value % scale).toString().padStart(decimals, '0').replace(/0+$/u, '');
  return `${value / scale}${fraction ? ',' + fraction : ''}`;
}
